import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SaveIcon from "@mui/icons-material/Save";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import {
  Alert,
  Box,
  Button,
  Grid,
  Link,
  Modal,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import "react-edit-text/dist/index.css";
import { useNavigate } from "react-router-dom";
import {
  calificarResultado,
  postLogRegisterActivity,
} from "../../controllers/operaciones";
import { useJobContext } from "../../hooks/Jobs";
import { formatoMarkdown } from "../../utils/formatoMarkdown";
import { generarPdfImprimir } from "../../utils/generarPdfImprimir";
import MarkDownEditor from "../MarkDownText/MarkDownEditor";
import MarkDownText from "../MarkDownText/MarkDownText";
import { ModalRating } from "../Modal/ModalRating";
import logoTuClase from "./icon/LOGO_TUCLASE.png";
import logoUmmIAPlan from "./icon/LOGO_Ummia.png";

const isLogReportsAvailable = process.env.REACT_APP_LOG_USER_REPORTS === "true"; // Aseguramos que el valor sea booleano

interface Props {
  readonly respuestaData: any;
}

function ChatGPT({ respuestaData }: Props) {
  const [openModal, setOpenModal] = useState(false);
  const [textarea, setTextarea] = useState<string>();
  //Estado para alternar entre la edición del texto
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [cargando] = useState(false);
  const [storyTellingUrl] = useState<string>();
  const { tipoEstructura, userId, proyectoId, resultadoId } = useJobContext();
  const [errorMessage] = useState<string>();
  const navigate = useNavigate();
  const [rating, setRating] = useState<number>(3);
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (respuestaData) {
      console.log("respuestaData", respuestaData);
      const markdownText = formatoMarkdown(respuestaData);
      setTextarea(markdownText);
    }
  }, [respuestaData]);

  const handleHome = () => {
    navigate("/asistente/menu");
  };

  const style = {
    width: "99%",
    height: "98%",
    bgcolor: "#FCFCFC",
    p: 4,
    overflowY: "auto",
  };

  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  const handleCloseStoryTellingVideo = () => setOpen(false);

  // Estilos para el Modal
  const styleStoryTellingVideo = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const extractUrl = (text: string) => {
    const regex = /(https?:\/\/[^\s]+[^.,\s"])/;
    const match = regex.exec(text);
    return match ? match[0] : "";
  };

  const storyTellingText = storyTellingUrl;
  const storyTellingUrlFormated = extractUrl(storyTellingText ?? "");

  const handleDescargarProyecto = async () => {
    //Unicamente se permite registrar actividad en base de datos si esta activado en las variables de entorno
    if (isLogReportsAvailable) {
      await postLogRegisterActivity(
        userId,
        "PROJECT_FILE_DOWNLOAD",
        tipoEstructura
      );
    }
    generarPdfImprimir(textarea);
  };

  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleRating = (n: number) => setRating(n);

  const handleGuardarCalificacion = async () => {
    console.log({ proyectoId });
    console.log({ resultadoId });
    console.log(
      `Calificando resultado: resultadoId={${resultadoId}}, rating={${rating}}`
    );
    if (rating && resultadoId) {
      await calificarResultado(resultadoId, rating);
    }
    handleCloseModal();
    setToast(true);
    setTimeout(() => {
      setToast(false);
    }, 2000);
  };

  return (
    <>
      <Snackbar
        open={toast}
        autoHideDuration={1200}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          ¡Su calificación fue realizada exitosamente!
        </Alert>
      </Snackbar>
      <ModalRating
        handleCloseModal={handleCloseModal}
        handleRating={handleRating}
        modalOpen={openModal}
        handleGuardarCalificacion={handleGuardarCalificacion}
        rating={rating}
      />
      <Grid sx={style}>
        {isEditing ? (
          <MarkDownEditor data={textarea} setEditedValue={setTextarea} />
        ) : (
          <Grid container>
            <Grid container>
              <Grid item>
                <img
                  src={logoTuClase}
                  alt="Logo"
                  style={{
                    height: "80px",
                    width: "auto",
                    objectFit: "cover",
                  }}
                />
              </Grid>
              <Grid item sx={{ m: "auto" }}>
                <img
                  src={logoUmmIAPlan}
                  alt="Logo"
                  style={{
                    height: "80px",
                    width: "auto",
                    objectFit: "cover",
                  }}
                />
              </Grid>
            </Grid>
            <Grid item>
              {/* <Markdown children={textarea} remarkPlugins={[remarkGfm]} /> */}
              <MarkDownText data={textarea} />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={8}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "row",
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: 0,
            zIndex: 1000,
            borderRadius: 100,
            justifyContent: "center",
            alignItems: "center",
            mb: 3,
            border: "1px solid #336B87",
            backgroundColor: "#1D3D4D",
          }}
        >
          <Tooltip
            title={isEditing ? "Guardar" : "Editar"}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1D3D4D",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#1D3D4D", // Color de la flecha
                },
              },
            }}
          >
            <Button
              variant="text"
              onClick={toggleEditing}
              sx={{
                borderRadius: 5,
                border: "0px solid #336B87",
                color: "#FFF",
              }}
            >
              {isEditing ? (
                <SaveIcon sx={{ fontSize: 35 }} />
              ) : (
                <EditIcon sx={{ fontSize: 35 }} />
              )}
            </Button>
          </Tooltip>
          {/* Boton para calificar respuesta */}
          <Tooltip
            title={"Calificar respuesta"}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1D3D4D",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#1D3D4D", // Color de la flecha
                },
              },
            }}
          >
            <Button
              variant="text"
              onClick={handleOpenModal}
              sx={{
                borderRadius: 5,
                border: "0px solid #336B87",
                color: "#FFF",
              }}
            >
              <StarHalfIcon />
            </Button>
          </Tooltip>

          <Tooltip
            title="Generar PDF"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1D3D4D",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#1D3D4D", // Color de la flecha
                },
              },
            }}
          >
            <Button
              variant="text"
              onClick={handleDescargarProyecto}
              sx={{
                borderRadius: 5,
                border: "0px solid #336B87",
                color: "#FFF",
              }}
              data-amplify-analytics-on="click"
              data-amplify-analytics-name={`click-on-imprimir-pdf-final`}
              data-amplify-analytics-attrs={`onClick:handleDescargarProyecto userId:${userId}, tipoEstructura=${tipoEstructura}`}
            >
              <PictureAsPdfIcon sx={{ fontSize: 35 }} />
            </Button>
          </Tooltip>

          <Tooltip
            title="Volver al menú"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1D3D4D",
                  color: "#FFF",
                  fontFamily: "Montserrat",
                  fontSize: "0.875rem",
                  padding: "8px 12px",
                  borderRadius: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#1D3D4D", // Color de la flecha
                },
              },
            }}
          >
            <Button
              variant="text"
              sx={{
                borderRadius: 5,
                border: "0px solid #336B87",
                color: "#FFF",
              }}
              onClick={handleHome}
            >
              <ArrowBackIcon sx={{ fontSize: 35 }} />
            </Button>
          </Tooltip>
        </Grid>

        <Modal
          open={open}
          onClose={handleCloseStoryTellingVideo}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleStoryTellingVideo}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Story Telling
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {cargando
                ? "Generando video, por favor espera..."
                : errorMessage ?? "Para ver el video, presione aquí:"}
            </Typography>
            {!cargando && !errorMessage && (
              <Link
                href={storyTellingUrlFormated}
                target="_blank"
                rel="noopener noreferrer"
              >
                {storyTellingUrlFormated}
              </Link>
            )}
          </Box>
        </Modal>
      </Grid>
    </>
  );
}

export default ChatGPT;
